import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import "./RamadaanPlanner.css";

export default function RamadaanPlanner() {
  const [plannerData, setPlannerData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await getContentById("ramadaanPlanner");
    setPlannerData(data);
  };

  return (
    <div className="RamadaanPlanner">
      <div className="ramadaanMain">
        <div className="ramadaanHeader">
          <h1>RAMADAAN</h1>
          <br />
          <h1>PLANNER</h1>
        </div>
        <div className="ramadaanPdf">
          {plannerData?.map((data) => (
            <div key={data.id}>
              <a
                href={`https://${data.link.fields.file.url}`}
                target="_blank"
                rel="noreferrer"
              >
                <img src="assets/pdf-icon.png" alt="pdf" />
                <p>Download</p>
              </a>
            </div>
          ))}
        </div>
        <div className="buttonsRamadaan">
          <button>Ramadaan Package</button>
          <button>Fasting</button>
          <button>COVID Guidelines</button>
        </div>
      </div>
      <div className="color"></div>
      <div className="ramadaanPlannerFoot">
        <div className="leftRamadaan">
          <h1>INTENTION FOR FASTING</h1>
          <img src="assets/image 18.png" alt="" />
        </div>
        <div className="rightRamadaan">
          <p>
            Recitation of the Niyyat/intention you can make to fast the entire
            month of Ramadan. Recorded by Imam Rashied in 2020 when the Masjid
            was closed.
          </p>
          <br />
          <a
            href="https://youtu.be/LzHjLUPzh0Q"
            target="_blank"
            rel="noreferrer"
          >
            https://youtu.be/LzHjLUPzh0Q
          </a>
        </div>
      </div>
      <div className="color"></div>
    </div>
  );
}
